import campaignConfig from '../../../../campaign-config/campaign.json';

export const globalColors = campaignConfig.global?.colors || {};

export const tutorDetailsChecklistConfig = campaignConfig.tutor_details?.checklist || {};
